import React from "react";
import { useQueryParam } from "use-query-param";
import Overview from "./subs/statistics/Index";
import Merchants from "./subs/merchants/Merchants";
import Settings from "./subs/settings/Settings";
import CommissionWallet from "./CommissionWallet";

export default function Index() {
  const { queryParams } = useQueryParam(window.location.href);

  switch (queryParams.q) {
    case "merchants":
      return <Merchants />;
    case "settings":
      return <Settings />;
    case "commission":
      return <CommissionWallet />;
    default:
      return <Overview />;
  }
}
